<div class="top-bar-container" [class.has-apps]="hasApps">
    <!-- Przycisk zostaje w drzewie także na home - inaczej nie ma czego animować przy wyjściu. -->
    <div class="apps-wrapper">
        <button mat-icon-button class="apps-button" routerLink="/home"
            [attr.tabindex]="hasApps ? null : -1" [attr.aria-hidden]="hasApps ? null : true">
            <mat-icon svgIcon="apps"></mat-icon>
        </button>
    </div>

    <div class="logo"></div>

    <div fxFlex fxFlexFill fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <app-chat *ngIf="userSettings.isChatEnabled()"></app-chat>

        <button mat-icon-button [matBadge]="notifications?.length" [matBadgeHidden]="notifications?.length == 0"
            [matMenuTriggerFor]="notificationsMenu">
            <mat-icon svgIcon="notifications"></mat-icon>
        </button>

        <mat-menu #notificationsMenu="matMenu">
            <span *ngIf="notifications?.length > 0; then showNotifications else showEmptyText"></span>
            <ng-template #showNotifications>
                <div *ngFor="let notification of notifications; let i = index" class="p-2">
                    <app-notification [notification]="notification" (deleteNotification)="deleteNotification($event)"></app-notification>
                </div>
                <div class="pl-2 pt-2">
                    <button mat-raised-button (click)="clearNotifications()">{{ 'clearNotifications' | translate }}</button>
                </div>
            </ng-template>
            <ng-template #showEmptyText>
                <button mat-menu-item>{{ 'noNotifications' | translate }}</button>
            </ng-template>
        </mat-menu>

        <ng-container *ngIf="{connected: (websocket.websocketConnection$ | async)} as ws">
            <button mat-icon-button [matMenuTriggerFor]="userMenu">
                <span class="avatar-with-badge">
                    <span class="user-avatar" [style.background-color]="getAvatarColor()">
                        {{ userProfileService.getUserProfile()?.username?.charAt(0)?.toUpperCase() }}
                    </span>
                    <span class="avatar-lang-badge">{{ langService.getLanguage() | uppercase }}</span>
                    <span class="ws-status-dot" [class.ws-status-dot--connected]="ws.connected"
                        [class.ws-status-dot--disconnected]="!ws.connected" [class.ws-status-dot--pressing]="dotPressing"
                        (mousedown)="$event.preventDefault(); $event.stopPropagation(); dotPressing = !ws.connected"
                        (mouseup)="dotPressing = false" (mouseleave)="dotPressing = false" (click)="reconnectFromDot($event, ws.connected)"
                        [matTooltip]="!ws.connected ? ('connectAgain' | translate) : null">
                        <svg *ngIf="!ws.connected" class="ws-reconnect-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
                                fill="currentColor" />
                        </svg>
                    </span>
                </span>
            </button>
        </ng-container>

        <mat-menu #userMenu="matMenu">
            <div class="user-menu-header">
                <span class="user-avatar user-avatar--xl" [style.background-color]="getAvatarColor()">
                    {{ userProfileService.getUserProfile()?.username?.charAt(0)?.toUpperCase() }}
                </span>
                <div class="user-menu-info">
                    <span class="user-menu-displayname">{{ userProfileService.getUserProfile()?.getDisplayName() }}</span>
                    <span class="user-menu-username">@{{ userProfileService.getUserProfile()?.username }}</span>
                </div>
            </div>
            <mat-divider></mat-divider>
            <button mat-menu-item *ngIf="(websocket.websocketConnection$ | async) != true" (click)="websocket.connectToWebsocket()">
                <mat-icon svgIcon="refresh"></mat-icon>
                <span>{{ 'connectAgain' | translate }}</span>
            </button>
            <button mat-menu-item routerLink="/management" *ngIf="managementEnabled">
                <mat-icon svgIcon="settings"></mat-icon>
                <span>{{ 'management' | translate }}</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item [matMenuTriggerFor]="langMenu">
                <mat-icon svgIcon="language"></mat-icon>
                <span>{{ 'lang' | translate }}</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="helpMenu">
                <mat-icon svgIcon="help"></mat-icon>
                <span>{{ 'help' | translate }}</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="userProfileService.logout()">
                <mat-icon svgIcon="exit_to_app"></mat-icon>
                <span>{{ 'logout' | translate}}</span>
            </button>
        </mat-menu>

        <mat-menu #langMenu="matMenu">
            <button mat-menu-item *ngFor="let lang of langService.getLangList()" (click)="langService.setLanguage(lang)"
                [disabled]="lang == langService.getLanguage()">
                <span class="lang-label">{{ lang | uppercase }}</span>
                <mat-icon svgIcon="done" *ngIf="lang == langService.getLanguage()" class="lang-selected"></mat-icon>
            </button>
        </mat-menu>

        <mat-menu #helpMenu="matMenu">
            <button mat-menu-item (click)="downloadInstruction()">
                <mat-icon svgIcon="files"></mat-icon>
                <span>{{ 'instruction' | translate }}</span>
            </button>
        </mat-menu>
    </div>

</div>